// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__gqrVC","active":"Tab_active__3VEBe","disabled":"Tab_disabled__3jyNh"};